import { useEffect, useState } from "react";

const PdfViewer = ({ url,height="100%" }) => {
  const [viewerUrl, setViewerUrl] = useState("");

  function base64ToBlob(base64, mime = "application/pdf") {
    const byteCharacters = atob(`${base64}`.replace('data:application/pdf;base64,', ''));
    const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  }

  useEffect(() => {
    const fetchPdfAsBlob = async () => {
      try {
        const blob = base64ToBlob(url);
        const blobUrl = URL.createObjectURL(blob);

        const pdfViewerPath = `${process.env.PUBLIC_URL}/pdfjs-5.1.91-dist/web/viewer.html`;
        const fullUrl = `${pdfViewerPath}?file=${encodeURIComponent(blobUrl)}`;

        setViewerUrl(fullUrl);
      } catch (error) {
        console.error("讀取 PDF 時發生錯誤:", error);
      }
    };

    fetchPdfAsBlob();
  }, [url]);
  // const viewerUrl = `${process.env.PUBLIC_URL}/pdfjs-5.1.91-dist/web/viewer.html?file=${url}`
  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     if (event.data === "scrollEnd") {
  //       console.log("PDF 滾到底了！");
  //       // 你可以改成任何你要的邏輯
  //     }
  //   };

  //   window.addEventListener("message", handleMessage);

  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // }, []);
  return <iframe width="100%" height={height} frameBorder="0" src={viewerUrl}></iframe>;
};

export default PdfViewer;
